import Vue from 'vue';
import testDefaults from './test-defaults';
import CoreConfigType from './coreConfigType';

export interface ConfigType extends CoreConfigType {
  // Declared by app
}

export default class Config {
  values: ConfigType;
  isLoaded: boolean;
  promise: Promise<ConfigType> | undefined;
  readonly configFile: string;

  constructor() {
    const env = Vue.$version.buildConfiguration;
    switch (env) {
      case 'production':
        this.configFile = 'config.production.json';
        break;
      case 'staging':
        this.configFile = 'config.staging.json';
        break;
      default:
        this.configFile = 'config.development.json';
    }

    this.values = {} as ConfigType;
    this.isLoaded = false;
  }

  refresh(): Promise<ConfigType> {
    if (Vue.$version.buildConfiguration === 'test') {
      this.values = testDefaults as ConfigType;
      return Promise.resolve(testDefaults as any);
    }

    const base = `${Vue.$appConfigPath}/`;
    const configUrl = base + this.configFile;
    this.isLoaded = false;
    this.promise = new Promise((resolve) => {
      Vue.$axios({ method: 'get', url: configUrl, baseURL: '' })
        .then((result) => {
          if (typeof (result.data) !== 'string') {
            this.values = result.data;
            Vue.$log.info(`[CONFIG] 📝 read config at: ${configUrl}`);
            Vue.$log.info(this.values);
          } else {
            Vue.$log.error('Unable to load config.json from server, invalid JSON, using default values instead');
            try {
            // This will fail
              JSON.parse(result.data);
            } catch (e) {
            // Otherwise there is no information what's wrong with the JSON
              Vue.$log.error(e);
              Vue.$log.error(`Expected valid JSON, but received this: ${result.data}`);
            }
            // configValues = defaultConfig;
          }
        })
        .catch((error) => {
          Vue.$log.error(`Error in request, unable to load config.json from server, 
                         using default values instead, error: ${error}`);
          // this.cache = defaultConfig;
          this.isLoaded = true;
        })
        .finally(() => {
          let baseUrl = this.values['networking-api-base-url'];
          let apiPath = this.values['networking-api-path'];
          if (!baseUrl.endsWith('/')) {
            baseUrl += '/';
          }
          if (!apiPath.endsWith('/')) {
            apiPath += '/';
          }
          const fullBaseUrl = baseUrl + apiPath;
          Vue.$axios.defaults.baseURL = fullBaseUrl;
          this.isLoaded = true;
          resolve(this.values);
        });
    });
    return this.promise;
  }
}
